//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { CompanyUsageLimitDTO } from 'src/app/core/models/system/company/company-usage-limit.dto';
import { EncryptionService } from '../../general/encryption-service';
import { environment } from 'src/environments/environment';
import { eSimApiPaths } from 'src/app/core/consts';
import { ExceptionsService } from '../../general/exceptions-service';
import { HttpClientService } from '../../general/http-client-service';
import { Injectable } from '@angular/core';
import { Observable, of, switchMap } from 'rxjs';
import { StringResultDTO } from 'src/app/core/interfaces/general/string-result';

@Injectable({ providedIn: 'root' })

export class CompanyUsageLimitsService {
  
  constructor(
    private encryptionService: EncryptionService,
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }
    
  public getById(id: number): Observable<CompanyUsageLimitDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>id, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const idEncSS=encResult.result;
                            
                            return this.httpClientService.getById(environment.eSimApi +
                                                                  eSimApiPaths.CompanyUsageLimits +
                                                                  "?idEncSS=" + idEncSS, undefined); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
  
  public getForCompany(companyID: number): Observable<CompanyUsageLimitDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyID, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const companyIdEncSS=encResult.result;
                            
                            return this.httpClientService.get<CompanyUsageLimitDTO>(environment.eSimApi +
                                                                                    eSimApiPaths.CompanyUsageLimits + "/" +
                                                                                    eSimApiPaths.CompanyUsageLimitsForCompany +
                                                                                    "?companyIdEncSS=" + companyIdEncSS); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
}
